import { schedulerService } from "./repository";

const resource = "/v1";

export default {
    data() {
        return {
            cancel: Object
        };
    },
    getCancelRequest() {
        return this.cancel;
    },
    async createCronSchedule(obj) {
        return schedulerService.post(`${resource}/cronscheduler/createschedule`, obj);
    },
    async updateCronSchedule(obj) {
        return schedulerService.put(`${resource}/cronscheduler/updateschedule`, obj);
    },
    async deleteCronSchedule(id) {
        return schedulerService.delete(`${resource}/cronscheduler/deleteschedule/${id}`);
    },
    async getCronSchedule(id) {
        return schedulerService.get(`${resource}/cronscheduler/getschedule/${id}`);
    },
    async getCronSchedules() {
        return schedulerService.get(`${resource}/cronscheduler/getschedules/`);
    }
};
